import styled from 'styled-components';

export const Container = styled.div`
  background-color: #ffffff;
  position: fixed;
  inset: 0 0 0 0;

  z-index: 9999;
`;
